import React, { useState } from 'react';
import styles from './AdminMobileMenuBar.module.css';
import Container from 'layouts/container/Container';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import hamBtn from 'routes/adminMobile/images/hambtn.png';
import configIcon from 'routes/vendorRe/images/config_icon.png';
import alertIcon from 'routes/vendorRe/images/alert_icon.png';
import AdminMobileModal from './AdminMobileModal';
import home1 from 'routes/vendorRe/images/homeIcon.png';
import useCustomAdminMobileMove from 'routes/adminMobile/hooks/useCustomAdminMobileMove';
import { mainHeaderHeight, mainPadd } from 'routes/adminMobile/constraints/AdminConst';

// 스타일 변수
const paddingTopBottom = '1.5rem 0';

const AdminMobileMenuBar = () => {
    const [modalShow, setModalShow] = useState(false);
    const {moveToHome} = useCustomAdminMobileMove();

    const handleClickModal = () => {
        setModalShow(true);
    };

    const closeModal = () => {
        setModalShow(false);
    };

    return (
        <div className={styles.fixed}>
            <Container height={mainHeaderHeight}>
                {/* 모달 처리 */}
                {modalShow && <AdminMobileModal callbackFn={closeModal} />}
                <HorizontalFlex padding={mainPadd}>
                    <FlexChild padding={paddingTopBottom}>
                        <img
                            className={styles.hamIcon}
                            src={hamBtn}
                            alt="모바일 내비게이션 버튼"
                            onClick={() => handleClickModal()}
                            />
                    </FlexChild>
                    <FlexChild padding={paddingTopBottom} justifyContent="flex-end">
                        <HorizontalFlex width="auto" gap="1.5rem">
                            <FlexChild justifyContent="flex-end">
                                <img
                                    className={styles.menuIcon}
                                    src={configIcon}
                                    alt="설정 아이콘"
                                    />
                            </FlexChild>
                            <FlexChild width="auto">
                                <img
                                    className={styles.menuIcon}
                                    src={alertIcon}
                                    alt="알림 아이콘"
                                    />
                            </FlexChild>
                            <FlexChild width="auto">
                                <img
                                    className={styles.menuIcon}
                                    src={home1}
                                    alt="메인으로 돌아가기 아이콘"
                                    onClick={() => moveToHome()}
                                    />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                </HorizontalFlex>
            </Container>
        </div>
    );
};

export default AdminMobileMenuBar;
